import React from "react";
import { Modal } from "antd";
import { useTranslation } from 'react-i18next';


const CustomModal = (props) => {
  
  const { t } = useTranslation();
  const { open, hideModal, performAction, title, confirmLoading, children} = props;
  return (
    <Modal
      title={title}
      open={open}
      onOk={performAction}
      onCancel={hideModal}
      okText={t("general.BTNok")}
      cancelText={t("general.BTNcancel")}
      confirmLoading={confirmLoading || false}
      maskClosable={false} 
    >
      <>{children}</>
    </Modal>
  );
};

export default CustomModal;